export default __webpack_public_path__ + "static/media/4.1f7bc662.png";